module.exports = __webpack_public_path__ + "static/media/chrome-mic-permission.1852e9c9.jpeg";